"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getIsForceCDNDowngrade: ()=>getIsForceCDNDowngrade,
    convertCDNRegion: ()=>convertCDNRegion,
    getForceCDNDowngradeRegion: ()=>getForceCDNDowngradeRegion
});
const external_config_js_namespaceObject = require("./config.js");
const convertCDNRegion = (value)=>{
    let result;
    switch(value){
        case 'global':
            result = 'global';
            break;
        case 'cn':
            result = 'cn';
            break;
        case 'us':
        case 'va':
            result = 'va';
            break;
        case 'gcp':
        case 'i18n':
            result = 'gcp';
            break;
        case 'sg':
            result = 'sg';
            break;
        default:
            result = void 0;
    }
    return result;
};
const getForceCDNDowngradeRegion = (downgrades)=>{
    const downgradeResult = downgrades.find((item)=>item.startsWith(external_config_js_namespaceObject.manualDowngradeKeys.FORCE_CDN_PREFIX));
    return convertCDNRegion(null == downgradeResult ? void 0 : downgradeResult.slice(external_config_js_namespaceObject.manualDowngradeKeys.FORCE_CDN_PREFIX.length));
};
const getIsForceCDNDowngrade = (downgrades)=>Boolean(getForceCDNDowngradeRegion(downgrades));
exports.convertCDNRegion = __webpack_exports__.convertCDNRegion;
exports.getForceCDNDowngradeRegion = __webpack_exports__.getForceCDNDowngradeRegion;
exports.getIsForceCDNDowngrade = __webpack_exports__.getIsForceCDNDowngrade;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "convertCDNRegion",
    "getForceCDNDowngradeRegion",
    "getIsForceCDNDowngrade"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
